"use strict";

import getModificationsByRef from "vfu/getModificationsByRef";

export default function shouldComponentUpdate(context, nextProps, nextState) {
	const stateDiff = getModificationsByRef(context.state, nextState);
	const propsDiff = getModificationsByRef(context.props, nextProps);
	return !!stateDiff || !!propsDiff;
}


// WEBPACK FOOTER //
// ./~/vwa/shouldComponentUpdate.js